import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import {Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {Virtuoso} from 'react-virtuoso';
import MosaicListItem from './mosaic-list-item.jsx';

import {fetchSeriesMosaicsRequest} from '@explorer/actions/mosaics';
import {
  EmptyMessageContainer,
  ErrorMessage,
  LoadingMessage,
} from '@explorer/components/ui/message-container';
import {getMosaics} from '@explorer/selectors/mosaics';

const MosaicsList = ({activeSeriesId}) => {
  const listRef = useRef();
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const mosaics = useSelector(state => getMosaics(state));
  const {
    error: mosaicsError,
    loading: mosaicsLoading,
    selected: selectedMosaic,
  } = useSelector(state => state.mosaics);

  useEffect(() => {
    if (activeSeriesId) {
      dispatch(fetchSeriesMosaicsRequest(activeSeriesId));
    }
  }, [activeSeriesId, dispatch]);

  const rowRenderer = index => {
    const mosaic = mosaics[index];

    return <MosaicListItem mosaic={mosaic} />;
  };

  if (mosaicsError) {
    return (
      <ErrorMessage
        message={t('sidebarsBasemap.errorLoadingBasemaps')}
        onRetry={() => dispatch(fetchSeriesMosaicsRequest(activeSeriesId))}
      />
    );
  } else if (mosaicsLoading) {
    return <LoadingMessage type="basemaps" />;
  } else if (!mosaicsLoading && mosaics.length === 0) {
    return (
      <EmptyMessageContainer
        icon={<ErrorOutlineOutlinedIcon fontSize="inherit" color="error" />}
        data-qe="no-basemaps-message"
      >
        <Typography variant="h6" color="inherit">
          {t('sidebarsBasemap.errorNoBasemaps')}
        </Typography>
      </EmptyMessageContainer>
    );
  }

  const activeIndex = selectedMosaic
    ? mosaics.findIndex(mosaic => mosaic.id === selectedMosaic?.id)
    : 0;

  return (
    <Virtuoso
      ref={listRef}
      totalCount={mosaics.length}
      defaultItemHeight={128}
      initialTopMostItemIndex={activeIndex >= 0 ? activeIndex : 0}
      itemContent={rowRenderer}
    />
  );
};

MosaicsList.propTypes = {
  activeSeriesId: PropTypes.string,
};

export default MosaicsList;
